import React, { useEffect } from "react";
import HirlevelForm from "../components/form-components/HirlevelForm"
import { MDBContainer } from 'mdb-react-ui-kit';
import { Helmet } from "react-helmet-async";

const HirlevelFeliratkozasPage = (props) => {

  useEffect(() => {
    setTimeout(() => window.scrollTo({
      top: 0,
      behavior: "smooth"
    }), 100);
  }, []);


  return (
    <>
    <Helmet>
        <title>Hírlevél feliratkozás - A Vértes Agorája</title>
    </Helmet>
    <section className="hirlevelpage-section" id ="hirlevelpage-section">
      <MDBContainer style={{maxWidth: "1008px"}} className='p-0'>
        <div className="hirlevel-title">
          <h1>Hírlevél feliratkozás</h1>
        </div>
      </MDBContainer>
    </section>
    <section className="hirlevelform-section" id ="hirlevelform-section" style={{paddingBottom: "85px"}}>
       <MDBContainer style={{maxWidth: "1008px"}} className='p-0'>
        <div className="hirlevelform-div">
          <HirlevelForm />
        </div>
      </MDBContainer>
    </section>
    </>
  );
};

export default HirlevelFeliratkozasPage;
